import React, { useEffect, useState, useContext, useRef } from 'react';
import packageJson from '../../package.json';
import { generateGUID } from '../utils/Utilities';
import './Components.css';
import { Cross2Icon } from '../icons/Icons';
import UserList from './UserList';
import TaskIdInput from './TaskIdInput';
import { GetCurrentSession } from '../isdlData/sessionData';

function CloneSessionModal({currentSession, cloneSessionResult}){

    const [newUseTaskId, setNewUseTaskId] = useState(false);
    const [newValidTaskId, setNewValidTaskId] = useState(false);
    const [newTaskId, setNewTaskId] = useState('');

    const descriptionInput = useRef(null);

    const [newGolfer, setNewGolfer] = useState(null);
    const [newValidGolferState, setNewValidGolferState] = useState(0); //0 = fail, 1 = warning (same user), 2 = pass

    const [validClone, setValidClone] = useState(false);

    useEffect(() => {
        if(descriptionInput && currentSession){
            descriptionInput.current.value = currentSession.Description;
        }
    },[]);

    useEffect(() => {
        let valid = true;

        //validated the task id
        if(newUseTaskId)
        {
            if(newValidTaskId){
                const regex = /^\d{4}-\d{5,6}-\d{2}$/;
                if (!regex.test(newTaskId))
                {
                    valid = false;
                }
            }else{
                valid = false;
            }
        }

        //validated the new golfer
        if(newValidGolferState !== 0){
            if(!newGolfer){
                valid = false;
            }
        }else{
            valid = false;
        }

        setValidClone(valid);
            
        }, [newUseTaskId, newValidTaskId, newTaskId, newGolfer, newValidGolferState]);

    const clickResult = (result) => {
        if(result){
            const passedData = {
                valid : true,
                data : {
                    id: generateGUID(),
                    TaskID : newTaskId,
                    Description : descriptionInput.current.value,
                    UserId : newGolfer.id,
                    UserName : newGolfer.FullName,
                    UserHandicap: Number.isFinite(newGolfer.Handicap) ? newGolfer.Handicap : -9999,
                    Date: formatDateUTC(),
                    DateLocal: formatDateLocal(),
                    AppDataVersion: packageJson.version,
                    DataSource: "LMReceiverWeb",
                }
            };
            cloneSessionResult(passedData);
        }else{
            const failedData = {
                valid : false
            };
            cloneSessionResult(failedData);
        }
    };

    const handleGolferChange = (golfer) => {
        setNewGolfer(golfer);

        if(golfer === null){
            setNewValidGolferState(0);
            return;
        }

        if(currentSession.UserId === golfer.id){
            setNewValidGolferState(1);
        }else{
            setNewValidGolferState(2);
        }
    }

    const useTaskIdResults = (e) => {
        setNewUseTaskId(e.target.checked);

        if(!e.target.checked){
            setNewValidTaskId(false);
            setNewTaskId('');
        }
    }

    const taskIdResults = (result) => {
        setNewValidTaskId(result.valid);
        setNewTaskId(result.taskId);
    }

    //Util
    function formatDateLocal() {
    const date = new Date();
    const timezoneOffset = -date.getTimezoneOffset(); // Offset in minutes
    const offsetHours = String(Math.floor(timezoneOffset / 60)).padStart(2, '0');
    const offsetMinutes = String(timezoneOffset % 60).padStart(2, '0');
    const offsetSign = timezoneOffset >= 0 ? '+' : '-';
    
    const localISO = date.getFullYear() +
        '-' + String(date.getMonth() + 1).padStart(2, '0') +
        '-' + String(date.getDate()).padStart(2, '0') +
        'T' + String(date.getHours()).padStart(2, '0') +
        ':' + String(date.getMinutes()).padStart(2, '0') +
        ':' + String(date.getSeconds()).padStart(2, '0') +
        offsetSign + offsetHours + ':' + offsetMinutes;
    
    return localISO;
    };
    
    function formatDateUTC() {
    const date = new Date();
    return date.toISOString();
    };

    return(
        <div className='modal-container' style={{height:"400px", maxWidth:"600px"}}>
            <button className='modal-close-button' onClick={() => clickResult(false)}><Cross2Icon width='30px' height='30px'/></button>
            <div className='modal-header'>Clone session</div>
            <div className='modal-content' style={{justifyContent:'start'}}>
                <div className='modal-option'>
                    <div style={{display:'flex', minWidth:'100px', justifyContent:'center'}}>Use Task Id</div>
                    <input type='checkbox' style={{width:'30px', height:'30px', marginLeft:'10px'}} onChange={useTaskIdResults}/>
                </div>

                {newUseTaskId && (
                <div className='modal-option'>
                    <div style={{display:'flex', minWidth:'100px', justifyContent:'center'}}>Task ID</div>
                    <div style={{flexGrow:'1', marginLeft:'10px', marginRight:'10px', height:'calc(100% - 15px)'}}>
                        <TaskIdInput result={taskIdResults} currentTaskId={currentSession.TaskID}/>
                    </div>
                </div>
                )}
                
                <div className='modal-option'>
                    <div style={{display:'flex', minWidth:'100px', justifyContent:'center'}}>Description</div>
                    <input type='text' ref={descriptionInput} style={{flexGrow:'1', marginLeft:'10px', marginRight:'10px', height:'calc(100% - 15px)'}}/>
                </div>
                <div className='modal-option'>
                    <div style={{display:'flex', minWidth:'100px', justifyContent:'center'}}>Golfer</div>
                    <div style={{flexGrow:'1', outline: newValidGolferState === 2 ? "0" : newValidGolferState === 0 ? "2px solid red" : "2px solid yellow" }}>
                        <UserList dbInitialized={true} UserChanged={handleGolferChange} />
                    </div>
                </div>
                
            </div>
            <div className="modal-footer" >
                <button className="button" disabled={!validClone} style={{width:'100px'}} onClick={() => clickResult(true)}>Clone</button>
            </div>
        </div>
            );
}

export default CloneSessionModal;